import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Blog from "../components/blog"
import Seo from "../components/seo"

type DataProps = {
  site: {
    buildTime: string
  }
}

const Aplikasioffice: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Blog>
    <Seo title="Aplikasi invoice akuntansi kantor" />
    <h1><strong><a href="/aplikasirestoran/">Aplikasi Office</a></strong></h1>
<img className="img-fluid" alt="aplikasi invoice akuntansi pembukuan kantor" src="/img/mesinkasironlineapp9.jpg"/>
    <p>
     Sempurnakan kebutuhan usaha kuliner dengan <a href="/aplikasioffice/">aplikasi restoran</a> kami , sangat membantu untuk pengusaha bisnsi restoran cafe rumah makan dan sejenis nya, berbagai variant system siap untuk digunakan mulai dari fastfood mode penjualan langsung, penggunaan pembagian divisi waiters kasir admin menjadikan kesempurnaan dalam bekerja via web app kami untuk digunakan, pada paket premium dan standard nikmati layanan tanpa batas include website yang terintegrasi secara otomatis dan langsung dengan <a href="/aplikasirestoran/">aplikasi restoran cafe rumah makan</a> , plus tentunya dukungan QR code menu digital dan android apk menyempurnakan segala nya.
    </p>
    <p>Mulai pilih applikasi resto mu sekarang, dan nikmati kebebasan point of sale app akses tanpa batas.</p>
<div className="row">

    <div className="p-3 p-md-5 col-12 col-md-4">
<img className="img-fluid" alt="aplikasi office invoice" 
src="https://mesinkasironline.web.app/img/invoice-android-ios-terbaru%20-%20Copy.jpg"/>
    </div>
    
    <div className="p-3 p-md-5 col-12 col-md-8">
<p>
    NEXT INVOICE APPS<br/>
Special untuk invoice system dengan metode pencatatan tender project yang dikerjakan , dukungan pembuatan faktur invoice maupun faktur pajak penjualan dengan PPN melengkapi pembukuan detail untuk menggunakan the next invoice generation ini. 
</p>
<Link to="/next/" className="button">More info</Link>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
<img className="img-fluid" alt="aplikasi invoice inventori kantor" 
src="https://mesinkasironline.web.app/img/software%20aplikasi%20system%20invoice%20stock%20inventory2.jpg"/>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-8">
<p>
    SIMPLE MANAGEMENT APPS<br/>
Temukan kemudahan dengan masing masing divisi memiliki aplikasi tersendiri dalam kemudahan bekerja dengan cepat via inventori stok apps khusus persediaan dan invoice untuk mencetak invoice dan pembayaran pelanggan dengan simple management app.
</p>
<Link to="/simple/" className="button">More info</Link>
    </div>

    <div className="p-3 p-md-5 col-12 col-md-4">
<img className="img-fluid" alt="aplikasi invoice" 
src="https://mesinkasironline.web.app/img/aplikasi%20invoice%20handphone%20android%20ios%20windows.jpg"/>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-8">
<p>
    IPOS APPS<br/>
Special untuk penjualan invoice dan berfokus pada penjualan dengan kemudahan nya serta laporan detail income pendapatan hingga stok inventori tersedia dengan meggunakan aplikasi ini untuk bekerja, dan tentunya harga murah menjadi piiihan.
</p>
<Link to="/ipos/" className="button">More info</Link>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
<img className="img-fluid" alt="aplikasi akuntansi accounting" 
src="https://1.bp.blogspot.com/-loDASoj8yCI/X-SW3BXuEZI/AAAAAAAAMTI/q1nQKSOkP6gRpjjM_15GLqZ0DRZa-EX8QCLcBGAsYHQ/s2000/aplikasi%2Bakuntansi%2Bonline%2Bmurah.jpg"/>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-8">
<p>
    ACCOUNTING AKUNTANSI APPS<br/>
Kebutuhan untuk pencatatan pembukuan akuntansi untuk debit dan credit semakin lebih mudah dengan hadirnya akuntansi accounting applikasi ini untuk digunakan .
</p>
<Link to="/akuntansi/" className="button">More info</Link>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
<img className="img-fluid" alt="software program akuntansi accounting" 
src="https://res.cloudinary.com/hockeycorp/image/upload/v1579970772/Software%20APlikasi%20Program%20kasir/6_acounting_vae9by.png"/>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-8">
<p>
    DIGITAL ACCOUNTING<br/>
Software program accounting akuntansi lengkap dengan digital accounting untuk digunakan dalam manajemen pembukuan, jurnal, neraca, dan lain nya.
</p>
<Link to="/accounting/" className="button">More info</Link>
    </div>
    </div>
    <Link to="/">Go back to the homepage</Link>
  </Blog>
)

export default Aplikasioffice

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
